module.exports = __webpack_public_path__ + "static/offices-content-image-4@2x-75042ef44ce1ad58d069d6dd43f50994.jpg";